<template>
  <RouterView />
  <SpeedInsights />

  <!-- Overlay -->
  <SupportedSnacksModal></SupportedSnacksModal>
  <LoadingOverlay></LoadingOverlay>
  <PermissionModal></PermissionModal>

  <!-- Snackbar -->
  <vue3-snackbar
    :error="'#f87171'"
    :success="'#32AF68'"
    :shadow="true"
    bottom
    :duration="6000"
  ></vue3-snackbar>
</template>

<script setup lang="ts">
import SnackbarHelperService from '@/services/snackbar-helper'
import { SpeedInsights } from '@vercel/speed-insights/vue'
import { onMounted } from 'vue'
import { Vue3Snackbar } from 'vue3-snackbar'
import LoadingOverlay from './components/LoadingOverlay.vue'
import PermissionModal from './components/modals/PermissionModal.vue'
import SupportedSnacksModal from './components/modals/SupportedSnacksModal.vue'

onMounted(() => {
  SnackbarHelperService.init()
})
</script>

<style scoped></style>
